import React from 'react';
import { useSetting } from '../../context/SettingContext';

const Footer = ({ t, isSidebarVisible }) => {
    const { setting } = useSetting();
    
    return (
        <footer className='flex p-5 bg-antiFlashWhite border-t-2 border-platinum text-xs sm:text-sm text-blackOlive font-medium'>
            <div
                className={`
                    flex w-full items-center justify-between
                    ${isSidebarVisible ? 'lg:ml-64' : 'ml-0'}
                    transition-all duration-300
                `}
            >
                <span>© {new Date().getFullYear()} {setting[`title_${t('languages.select')}`]}</span>
                <span>v1.1.0</span>
            </div>
        </footer>
    );
};

export default Footer;
